import { TitleCasePipe } from '@angular/common';
import { Component, Input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-alert',
  templateUrl: './alert.component.html',
  imports: [TranslateModule, TitleCasePipe]
})
export class AlertComponent {

  @Input() type: string;
  @Input() message: string;
  @Input() isAlertMessageTranslated = false;
}
